module.exports = "pegasus/assets/preview-15.png";